import 'whatwg-fetch'
import { checkStatus, parseJSON } from '../../js/modules/helper-functions'

export const settings = {
  selector: '.js-contact-form',
  message: '.js-contact-form-msg',
  tabs: '.js-contact-form-tabs input[type="radio"]',
  tab_selected: '.js-contact-form_selected_tab',
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })

  let tabs = document.querySelectorAll( settings.tabs )
  Array.from( tabs ).forEach(( tab ) => {
    tab.addEventListener( 'click', ( e ) => {
      // hide all
      Array.from( document.querySelectorAll( settings.tabs )).forEach(( tab ) => {
        document.querySelector( '#' + tab.dataset.control ).style.display = 'none'
      })
      let elem = document.querySelector( '#' + e.target.dataset.control )
      elem.style.display = 'block'
      let input = document.querySelector( settings.selector + ' ' + settings.tab_selected )
      input.value = tab.value
    })
  })
  if ( tabs.length > 0 ) {
    tabs[0].click()
  }
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  handleFormSubmit( element )
}


/**
 * Handle form submit.
 *
 * @param {DOMNode} form
 */
function handleFormSubmit( form ) {
  form.addEventListener( 'submit', ( e ) => {
    e.preventDefault()
    const formData = new FormData( form )
    formData.set( 'requestResponse', formData.get( 'requestResponse' ) === 'on' )
    fetch( '/wp-json/sponda/v1/feedback', {
      method: 'POST',
      body: formData
    })
      .then( checkStatus )
      .then( parseJSON )
      .then(() => {
        form.reset()
        success()
      })
      .catch(( err ) => {
        console.error( err )
        error()
      })
  })
}

/**
 * Call on form success.
 */
function success() {
  const msgEl = document.querySelector( settings.message )
  msgEl.classList.remove( 'error' )
  msgEl.textContent = msgEl.dataset.success
}

/**
 * Call on form error.
 */
function error() {
  const msgEl = document.querySelector( settings.message )
  msgEl.classList.add( 'error' )
  msgEl.textContent = msgEl.dataset.error
}
